<template>
  <div class="scroll-trigger">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ScrollTrigger",
  props: {
    options: {
      type: Object,
      default: () => ({
        root: null,
        threshold: "0",
        rootMargin: "0px 0px 0px 0px",
      }),
    },
  },
  emits: ["intersected"],
  data: () => ({
    observer: null,
  }),
  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        console.log("in view");
        this.$emit("intersected");
      }
    }, this.options);
    this.observer.observe(this.$el);
  },
  unmounted() {
    this.observer.disconnect();
  },
};
</script>
